import { z } from 'zod';
import { moneySchema } from '../money';

/**
 * Mitarbeiter als Auswahl-Liste (id + Name + abgeleitetes Kürzel) — z. B. für das
 * „Zeichen"-Feld der Projektcheckliste. Kürzel wird serverseitig aus Vor-/Nachname
 * abgeleitet (z. B. „Felix Perner" → „FP"); es gibt kein eigenes Kürzel-Stammfeld.
 */
export const employeeOptionSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  initials: z.string(),
});
export type EmployeeOption = z.infer<typeof employeeOptionSchema>;

/** Mitarbeiter (Modul hr). */
export const createEmployeeSchema = z.object({
  number: z.string().trim().min(1).max(32),
  firstName: z.string().trim().min(1).max(120),
  lastName: z.string().trim().min(1).max(120),
  email: z.string().trim().email().max(200).optional(),
  /** Position als Soft-Ref auf die Positions-Stammdaten (ADR 0016); füllt den Satz vor. */
  positionId: z.string().uuid().nullable().optional(),
  /** Positions-Name (Snapshot, Anzeige) — i. d. R. aus der Position übernommen. */
  position: z.string().trim().max(120).optional(),
  /** Verrechnungs-Stundensatz für die Ist-Kosten aus Zeitbuchungen (ADR 0016). */
  hourlyRate: moneySchema.optional(),
  /** Verknüpfung mit einem Login-User (für die Self-Service-Zeiterfassung). */
  userId: z.string().uuid().nullable().optional(),
  /** Urlaubsanspruch in Tagen pro Jahr (Phase 2, vom Admin/HR gepflegt). */
  annualVacationDays: z.number().int().min(0).max(366).nullable().optional(),
  /** Resturlaub aus dem Vorjahr in Tagen. */
  vacationCarryoverDays: z.number().int().min(0).max(366).nullable().optional(),
  isActive: z.boolean().default(true),
});
export type CreateEmployeeInput = z.infer<typeof createEmployeeSchema>;

export const updateEmployeeSchema = createEmployeeSchema.partial();
export type UpdateEmployeeInput = z.infer<typeof updateEmployeeSchema>;

export const employeeResponseSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  number: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().nullable(),
  positionId: z.string().uuid().nullable(),
  position: z.string().nullable(),
  hourlyRate: moneySchema.nullable(),
  userId: z.string().uuid().nullable(),
  annualVacationDays: z.number().int().nullable(),
  vacationCarryoverDays: z.number().int().nullable(),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type EmployeeResponse = z.infer<typeof employeeResponseSchema>;
